import {
  brokerGuidStore,
  commercialCombinedFormStore,
} from '@/store/CommercialCombinedFormStore'
import { RouterEnum } from '@/router/base'

/**
 * Resets both the broker guid store and the commercial combined form store.
 * If `redirect` is true, it will then redirect to the appropriate starting page.
 * If it is false, it will not redirect.
 *
 * @param {boolean} redirect - whether to redirect after resetting the stores
 * @returns {null}
 */
export const resetEverything = (redirect = true) => {
  const CCReset = commercialCombinedFormStore.getState().CCReset
  const guidReset = brokerGuidStore.getState().guidReset
  CCReset()
  guidReset()

  if (window.location.href.includes('/broker') && redirect) {
    window.location.href = RouterEnum.BROKER + '/' + RouterEnum.BROKER_BUY
  }

  if (window.location.href.includes('/back-office') && redirect) {
    window.location.href =
      RouterEnum.BACKOFFICE + '/clean/' + RouterEnum.NEW_QUOTE
  }
  return null
}
